import * as React from "react";

export default function IconBeauty(props) {
    return (
        <svg width={20} height={24} viewBox="0 0 20 24" fill="none" {...props}>
            <path
                d="M17.384 24H1.392c.591-2.964 2.026-5.557 4.642-7.245.253-.165.506-.33.717-.494 1.097 1.276 2.194 2.51 3.629 3.417.844.535 1.73.905 2.7 1.029.506.37 1.055.617 1.646.823 1.223.453 2.11 1.317 2.658 2.47z"
                fill="url(#prefix__paint0_linear)"
            />
            <path
                d="M19.704 11.033c.422.7.085 1.44-.717 1.523-.844.082-1.688.082-2.447.453-.717.37-1.181 1.029-1.519 1.687a254.068 254.068 0 00-1.519 3.294c-.084.206-1.097 2.017-1.013 2.1.085.123.211.246.338.329.084.082.21.164.295.247a6.343 6.343 0 01-2.7-1.03c-1.435-.905-2.532-2.14-3.629-3.416.59-.453 1.097-.988 1.35-1.688.254-.7.254-.988-.422-1.276-.97-.453-1.94-1.03-2.658-1.894-.21-.288-.464-1.07-.844-1.153a3.284 3.284 0 00-.886-.123c-.844-.083-1.603-.37-2.236-.988C.507 8.48.169 7.657.042 6.834c-.169-1.441.97-2.47 2.11-3.129.38-.206.76-.33 1.181-.33.338 0 .76.165 1.055-.082.127-.123.211-.247.295-.411C6.498-.206 11.35-.658 14.388.823c1.14.535 3.291 1.976 3.165 3.417-.043.659.253 1.112.76 1.482.506.33.97.7 1.434 1.07.295.206.295.494.042.7-.169.165-.338.33-.506.453-.17.165-.17.33 0 .494a.581.581 0 00.168.124c.296.205.296.329.127.617-.127.165-.253.33-.422.535.127.041.211.041.295.083.085.04.17.082.253.123.127.124.212.247.085.412-.295.288-.295.37-.085.7z"
                fill="url(#prefix__paint1_linear)"
            />
            <defs>
                <linearGradient
                id="prefix__paint0_linear"
                x1={7.397}
                y1={27.344}
                x2={14.233}
                y2={13.33}
                gradientUnits="userSpaceOnUse"
                >
                <stop stopColor="#BF2D6D" />
                <stop offset={0.989} stopColor="#F48796" />
                </linearGradient>
                <linearGradient
                id="prefix__paint1_linear"
                x1={9.22}
                y1={20.345}
                x2={10.598}
                y2={-2.242}
                gradientUnits="userSpaceOnUse"
                >
                <stop stopColor="#5350B0" />
                <stop offset={0.994} stopColor="#5BA3FF" />
                </linearGradient>
            </defs>
        </svg>
    )
}
